

import { makeStyles } from 'tss-react/mui';
import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  ContentTemplate,
  Grid,
  HeaderInput,
  HeaderTemplate,
  SectionHeader,
  SingleSelectionRadio,
} from 'web-library';
import { AUTHORITY_NAMES } from 'web-library/models/AuthorityFunctions';
import CandidateResitRegistration from './CandidateResitRegistration';
import CoordinatorResitRegistration from './CoordinatorResitRegistration';
import { useGetUserAuthorities } from '../../../../api-refactored/user/useGetUserAuthorities';

const useStyles = makeStyles()((theme) =>
({
  container: {},
  formContainer: {},
}));

const OopAdminResitRegistration = () => {
  const [selectedType, setSelectedType] = useState<string>('');
  const [hasCreate, setHasCreate] = useState<boolean>(false);

  const { classes } = useStyles();

  const { t } = useTranslation();

  const { data: authorities = [] } = useGetUserAuthorities();

  useEffect(() => {
    if (authorities.includes(AUTHORITY_NAMES.CP_ADMIN_GRANT_RESIT_UNIQUE_LINK_CREATE)) {
      setHasCreate(true);
    }
  }, [authorities]);

  /** handle Type radio changes
   * */
  const onTypeChange = (currentType: string) => {
    setSelectedType(currentType);
  };

  const radioButtonDataList = useMemo(
    () =>
      hasCreate
        ? [
          { label: 'Candidate', value: 'candidate' },
          { label: 'Coordinator', value: 'coordinator' },
        ]
        : [{ label: 'Candidate', value: 'candidate' }],
    [hasCreate]
  );

  return (
    <>
      <HeaderTemplate>
        <HeaderInput
          label=" Account Type"
          input={
            <SingleSelectionRadio
              color="primary"
              value={selectedType}
              onChange={(event) => {
                onTypeChange(event.target.value);
              }}
              data={radioButtonDataList}
            />
          }
        />
      </HeaderTemplate>

      {selectedType && (
        <ContentTemplate type="full">
          <SectionHeader title={t('resit->>ResitRoute.Resit Registration')} />

          <Grid container className={classes.formContainer} direction="column">
            {selectedType === 'candidate' && <CandidateResitRegistration />}
            {selectedType === 'coordinator' && <CoordinatorResitRegistration />}
          </Grid>
        </ContentTemplate>
      )}
    </>
  );
};
export default OopAdminResitRegistration;
